import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import MoqDetail from './components/MoqDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageMoq',
  components: {
    MoqDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;